import React, { useRef } from 'react';
import './Home.less';
import { HomeCard } from 'components';
import { Typography } from 'antd';
import { capitalCase } from 'change-case';
import links from './links';
import useGravityCollapse from './useGravityCollapse';

const { Title } = Typography;

const Home = () => {
  const containerRef = useRef(null);
  const triggerGravity = useGravityCollapse(containerRef);

  return (
    <div className="home-page" ref={containerRef}>
      <button
        type="button"
        className="home-gravity-hotspot"
        aria-hidden="true"
        aria-label="easter egg"
        tabIndex={-1}
        onClick={triggerGravity}
      />
      {Object.entries(links).map(([sectionTitle, sectionLinks]) => (
        <div className="home-card-section" key={sectionTitle}>
          <Title level={4} data-gravity>
            {capitalCase(sectionTitle)}
          </Title>
          <div className="home-card-grid">
            {sectionLinks.map((link) => (
              <div key={link.title} data-gravity>
                <HomeCard {...link} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Home;
